






















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ApplicationNotesModal from '@/components/ApplicationNotesModal.vue';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import fields from '@/fields.config';

@Component({
  components: {
    ApplicationNotesModal,
  },
})
export default class SiderBar extends Vue {
  @Prop({ default: false }) public isShowApplicantBtn!: boolean;
  @Prop({ default: () => [] }) public menuList!: any;
  public newMenuList: any = [];
  public location: any = {};
  public teacherList: any = {};
  public config = config;
  public fields = fields;
  public visible: boolean = false;
  public value: any = '';
  public newStudent: any = [];

  public radioStyle: any = {
    display: 'block',
    // border:'1px solid red',
    height: '30px',
    lineHeight: '30px',
    margin: '8px 0',
  };
  public created(): void {
    for (const item in config) {
      if (item === this.school) {
        this.location = config[item].location;
        this.teacherList = config[item].teacherList;
      }
    }
  }
  public onChange(e: any) {}
  @Watch('menuList', { immediate: true })
  public getNewList() {
    if (this.menuList) {
      this.newMenuList = this.menuList.filter(item => item.status === '1117' || item.status === '0000');
    }
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
  public handleOk() {
    // const newValue = this.value;
    if (this.value !== 0) {
      this.newMenuList.map(item => {
        if (this.value === item.studentId) {
          this.newStudent = item;
          this.jumpToDetail(item.studentId, item.draftId, item.status);
        }
      });
    } else {
      this.$router.push({ name: 'application' });
    }
    // if (newValue)
    //   if (this.value === 0) {
    //
    //   }
    this.visible = false;
  }
  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }

  // public jumpToDetail(item: any): void {
  //   if (item.studentId && item.status === '1101') {
  //     this.$router.push({ name: 'studentDetail', query: { studentId: item.studentId } });
  //   } else {
  //     if (item.studentId && item.draftId === '') {
  //       this.$router.push({ name: 'application', query: { studentId: item.studentId } });
  //     } else {
  //       this.$router.push({ name: 'application', query: { isDraft: 'true', draftId: item.draftId } });
  //     }
  //   }
  // }
  public jumpToDetail(studentId: string, draftId: string, status: string): void {
    if (studentId && (status === '1101' || status === '1106')) {
      this.$router.push({ name: 'studentDetail', query: { studentId } });
    } else {
      if (studentId && draftId === '') {
        this.$router.push({ name: 'application', query: { studentId } });
      } else {
        this.$router.push({ name: 'application', query: { isDraft: 'true', draftId, studentId } });
      }
    }
  }
  public jumpToApplicantForm(): void {
    if (this.newMenuList && this.newMenuList.length !== 0) {
      this.visible = true;
    } else {
      this.$router.push({ name: 'application' });
    }
  }
  public get locale(): string {
    return this.$i18n.locale;
  }

  public showModal(): void {
    const formRef: any = this.$refs.confirmModal;
    if (formRef) {
      this.$nextTick(() => {
        formRef.showConfirm();
      });
    }
  }
}
